import type { GridColDef } from "@mui/x-data-grid-premium";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { workflowTypeCaptionMap } from "@entrilia/shared/utilities/enumCaptions";
import type { InvestorChangeRequest } from "../../../api/types/workflowTypes";
import WorkflowStatusTag from "./WorkflowStatusTag";
import { hasApprovalInfo } from "./changeRequestsFormatters";

interface Params {
  getDetailsPath?: (workflowId: string) => string;
  detailsNavigationState?: unknown;
}

export const getColumnDefinitions = ({
  getDetailsPath,
  detailsNavigationState,
}: Params): GridColDef<InvestorChangeRequest>[] => [
  {
    field: "referenceCode",
    headerName: "Reference",
    flex: 1,
    minWidth: 120,
    renderCell: ({ row }) => (
      <GridTextHoverLink
        to={getDetailsPath?.(row.workflowId)}
        state={detailsNavigationState}
        text={row.referenceCode}
      />
    ),
  },
  {
    field: "workflowType",
    headerName: "Type",
    flex: 1,
    minWidth: 160,
    valueFormatter: (value) => workflowTypeCaptionMap[value] ?? value,
  },
  {
    field: "investorName",
    headerName: "Investor",
    flex: 2,
    minWidth: 160,
  },
  {
    field: "workflowStatus",
    headerName: "Status",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => <WorkflowStatusTag workflowStatus={row.workflowStatus} />,
  },
  {
    field: "requestedByUserName",
    headerName: "Requested by",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "requestedAt",
    headerName: "Requested at",
    flex: 1,
    minWidth: 160,
    valueFormatter: (value) => convertISODateTime(value),
  },
  {
    field: "approvalStatusUpdatedByUserName",
    headerName: "Reviewed by",
    flex: 1,
    minWidth: 160,
    valueGetter: (_, row) => (hasApprovalInfo(row.workflowStatus) ? (row.approvalStatusUpdatedByUserName ?? "-") : "-"),
  },
  {
    field: "approvalStatusUpdatedAt",
    headerName: "Reviewed at",
    flex: 1,
    minWidth: 160,
    valueGetter: (_, row) =>
      hasApprovalInfo(row.workflowStatus) && row.approvalStatusUpdatedAt
        ? (convertISODateTime(row.approvalStatusUpdatedAt) ?? "-")
        : "-",
  },
];
